import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { ArrowLeft, Calendar } from "lucide-react";
import "./EventHeader.css";
import { useAuth } from "../../context/auth";

const EventHeader = ({
  title,
  status,
  date,
  backPath,
  showStatus = true,
  showDate = true,
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const statusStyles = {
    Upcoming: { bg: "#FFF8E6", text: "#DBA419" },
    Live: { bg: "#E6FFEE", text: "#0E8A3E" },
    Complete: { bg: "#F0F0F0", text: "#555555" },
  };

  const { user } = useAuth();

  const userType = user?.activeRole;
  const safeTitle = title || "Untitled Event";
  const safeStatus = statusStyles[status] ? status : "Upcoming";
  const safeDate = date || "";

  if (status && !statusStyles[status]) {
    // console.warn(
    //   `Invalid status "${status}" provided to EventHeader. Defaulting to "Upcoming".`
    // );
  }

  const currentStatusStyle = statusStyles[safeStatus] || statusStyles.Upcoming;

  const handleBackClick = () => {
    if (backPath) {
      navigate(backPath);
      return;
    }

    const paymentPages = ["/checkout", "/payment-result"];
    const homePath = `/home/${userType}`;

    const currentPath = location.pathname;

    if (paymentPages.some((page) => currentPath.startsWith(page))) {
      navigate(homePath, { replace: true });
      return;
    }

    const prevState = window.history.state;
    const prevPath = prevState?.prevPath || "";
    if (paymentPages.some((page) => prevPath.startsWith(page))) {
      navigate(homePath, { replace: true });
      return;
    }

    if (currentPath === homePath || currentPath === "/create-event") {
      navigate(homePath, { replace: true });
    } else {
      navigate(homePath, { replace: true });
    }
  };

  return (
    <div className="event-header">
      <div className="event-header-left">
        <button className="event-header-back-button" onClick={handleBackClick}>
          <ArrowLeft size={20} />
          <span>Back </span>
        </button>

        <h1 className="event-header-title">{safeTitle}</h1>
      </div>

      <div className="event-header-right">
        {showStatus && (
          <div
            className="event-header-status-badge"
            style={{
              backgroundColor: currentStatusStyle.bg,
              color: currentStatusStyle.text,
            }}
          >
            {safeStatus}
          </div>
        )}

        {showDate && (
          <div className="event-header-date-card">
            <div className="event-header-calendar-icon">
              <Calendar size={20} />
            </div>
            <div className="event-header-date-info">
              <p>Event Date</p>
              <h3>{safeDate}</h3>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default EventHeader;
